<div class="form-modal modal-theme" style="width: 700px">
  <h1 mat-dialog-title>{{'STATE_OPTIONS'|translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
              (click)="changeCollapse()">
              <h5 class="panel-title">
                <i class="fas fa-history"></i>
                <strong>{{'HISTORY'|translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': !collPnPopup1 , 'fa-caret-up': collPnPopup1 }"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse">
              <div class="form-group">
                <div class="col-sm-12">
                  <!-- Se tiver separadores -->
                  <mat-tab-group (selectedTabChange)="onTabChange($event)" *ngIf="tabs && tabs.length > 0">
                    <mat-tab id="General">
                      <ng-template mat-tab-label>
                        <span>{{'GENERAL'|translate}}</span>
                      </ng-template>
                      <div class="row">
                        <div class="col-sm-12" style="overflow: auto;">
                          <table class="table table-bordered display" cellspacing="0">
                            <thead>
                              <tr>
                                <th>
                                  <strong>{{ 'DATE' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'FROM' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'TO' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'DONE_BY' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'NOTES' | translate }}</strong>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let log of logs">
                                <td class="verticalMiddle">{{log.EventDate}}</td>
                                <td class="verticalMiddle">{{log.FromStateName}}</td>
                                <td class="verticalMiddle">{{log.ToStateName}}</td>
                                <td class="verticalMiddle">{{log.UserName}}</td>
                                <td class="verticalMiddle text-center">
                                  <button type="button" class="btn btn-default" title="{{'NOTES' | translate}}"
                                    (click)="showNotes(log.Notes)" *ngIf="log.Notes">
                                    <i
                                      class="fas fa-sticky-note color-notes backwhite"></i>&nbsp;{{'NOTES' | translate}}
                                  </button>
                                </td>
                              </tr>
                              <tr *ngIf="!logs || logs.length === 0">
                                <td class="verticalMiddle text-center" colspan="5">
                                  {{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </mat-tab>

                    <mat-tab *ngFor="let tab of tabs" [id]="tab.StateType">
                      <ng-template mat-tab-label>
                        <span>{{tab.TabName|translate}}</span>
                      </ng-template>
                      <div class="row">
                        <div class="col-sm-12">
                          <table class="table table-bordered display" cellspacing="0">
                            <thead>
                              <tr>
                                <th>
                                  <strong>{{ 'DATE' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'FROM' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'TO' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'DONE_BY' | translate }}</strong>
                                </th>
                                <th>
                                  <strong>{{ 'NOTES' | translate }}</strong>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let log of tab.logs">
                                <td class="verticalMiddle">{{log.EventDate}}</td>
                                <td class="verticalMiddle">{{log.FromStateName}}</td>
                                <td class="verticalMiddle">{{log.ToStateName}}</td>
                                <td class="verticalMiddle">{{log.UserName}}</td>
                                <td class="verticalMiddle text-center">
                                  <button type="button" class="btn btn-default" title="{{'NOTES' | translate}}"
                                    (click)="showNotes(log.Notes)" *ngIf="log.Notes">
                                    <i
                                      class="fas fa-sticky-note color-notes backwhite"></i>&nbsp;{{'NOTES' | translate}}
                                  </button>
                                </td>
                              </tr>
                              <tr *ngIf="!tab.logs || tab.logs.length === 0">
                                <td class="verticalMiddle text-center" colspan="5">
                                  {{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </mat-tab>
                  </mat-tab-group>

                  <!-- Se não tiver separadores -->
                  <div class="row" *ngIf="!tabs || tabs.length === 0">
                    <div class="col-sm-12" style="overflow: auto;">
                      <table class="table table-bordered display" cellspacing="0">
                        <thead>
                          <tr>
                            <th>
                              <strong>{{ 'DATE' | translate }}</strong>
                            </th>
                            <th>
                              <strong>{{ 'FROM' | translate }}</strong>
                            </th>
                            <th>
                              <strong>{{ 'TO' | translate }}</strong>
                            </th>
                            <th>
                              <strong>{{ 'DONE_BY' | translate }}</strong>
                            </th>
                            <th>
                              <strong>{{ 'NOTES' | translate }}</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let log of logs">
                            <td class="verticalMiddle">{{log.EventDate}}</td>
                            <td class="verticalMiddle">{{log.FromStateName}}</td>
                            <td class="verticalMiddle">{{log.ToStateName}}</td>
                            <td class="verticalMiddle">{{log.UserName}}</td>
                            <td class="verticalMiddle text-center">
                              <button type="button" class="btn btn-sm btn-default" title="{{'NOTES' | translate}}"
                                (click)="showNotes(log.Notes)" *ngIf="log.Notes">
                                <i class="fas fa-sticky-note color-notes backwhite"></i>&nbsp;{{'NOTES' | translate}}
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="!logs || logs.length === 0">
                            <td class="verticalMiddle text-center" colspan="5">{{ 'NO_RESULTS_WERE_FOUND' | translate }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form [formGroup]="form" *ngIf="form">
        <div class="panel panel-default" *ngIf="allowChange && steps && steps.length > 0">
          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
            (click)="collPnPopup2 = !collPnPopup2">
            <h5 class="panel-title">
              <i class="fas fa-tasks"></i>
              <strong>{{'STATE_CHANGE'|translate}}</strong>
              <i class="collapse-icon fas"
                [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
            </h5>
          </div>
          <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
            <div class="form-group">
              <div class="col-sm-12">
                <mat-radio-group class="custom-radio-group display-inline" formControlName="Step"
                  (change)="valueChanged(1)">
                  <mat-radio-button *ngFor="let step of steps" class="custom-radio-button" [value]="step.ID">
                    {{isGenericWorkflow ? step.Name :step.ActionVerb}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12">
                <mat-form-field class="full-width">
                  <textarea matInput placeholder="{{'OBSERVATIONS'|translate}}" formControlName="Notes"
                    (change)="valueChanged(1)"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="panel panel-default" *ngIf="isGenericWorkflow && steps && steps.length > 0">
          <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup3"
            (click)="collPnPopup3 = !collPnPopup3">
            <h5 class="panel-title">
              <i class="fas fa-tasks"></i>
              <strong>{{'ASSIGN_ACTIONS_TO_ANOTHER_USER'|translate}}</strong>
              <i class="collapse-icon fas"
                [ngClass]="{'fa-caret-down': collPnPopup3, 'fa-caret-up': !collPnPopup3}"></i>
            </h5>
          </div>
          <div id="collPnPopup3" class="panel-body no-horizontal-padding collapse in">
            <div class="form-group">
              <div class="col-sm-12">
                <mat-form-field class="full-width">
                  <mat-select placeholder="{{'USERNAME'|translate}}" formControlName="SelectedUser"
                    (selectionChange)="valueChanged(2)">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let item of users" [value]="item.ID">{{ item.Name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        <i class="fas fa-times"></i>&nbsp;{{'CLOSE' | translate}}
      </button>

      <button type="button" class="btn btn-primary" title="{{'BUTTON.CHANGE' | translate}}" (click)="save()"
        *ngIf="form && (allowChange || isGenericWorkflow) && steps && steps.length > 0"
        [disabled]="form && !form.get('Step').value && !form.get('SelectedUser').value">
        <i class="fas fa-check"></i>&nbsp;{{'BUTTON.CHANGE' | translate}}
      </button>
    </div>
  </div>
</div>